/**
 * 获取图片的原始尺寸
 * @param {String} url 图片路径
 * @param {String} errMsg 图片加载失败 提示语
 * @returns
 */
export async function getImageSize(url, errMsg = "Failed to load image") {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = () => {
      reject(new Error(errMsg));
    };
    img.src = url;
  });
}

export async function getImageSizeWithFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = reject;
      img.src = event.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
